// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 数据存储
import store from './store'

import axios from 'axios';
import VueAxios from 'vue-axios';
//引入全局变量
import globalVariable from './global/constant';

// 解决双击菜单是控制台弹出报错信息的问题
import Router from 'vue-router';

// import wx from 'weixin-js-sdk';

// 引入icon
import './assets/iconfont/iconfont.css';
import './assets/iconfont/iconfont.ttf';
import './assets/iconfont/iconfont.eot';
import './assets/iconfont/iconfont.svg';
import './assets/iconfont/iconfont.woff';

import 'vant/lib/icon/local.css';

import {
	Button,
	Icon,
	Image,
	Loading,
	Grid,
	GridItem,
	Field,
	Notify,
	Toast,
	Overlay,
	Dialog,
	DatetimePicker,
	Popup,
	Picker,
	Collapse,
	CollapseItem,
	Cell,
	CellGroup,
	Checkbox,
	CheckboxGroup,
	RadioGroup,
	Radio,
	Step,
	Steps,
	Search,
	Uploader,
	Tab,
	Tabs,
	Divider,
	Tabbar,
	TabbarItem,
  NavBar
	} from 'vant';

Vue.use(Button).use(Icon).use(Image).use(Loading).use(Grid).use(GridItem).use(Field).use(CellGroup).use(Notify).use(Toast).use(Overlay).use(Dialog).use(DatetimePicker).use(Popup).use(Picker).use(Collapse).use(CollapseItem).use(Cell).use(CellGroup).use(Checkbox).use(CheckboxGroup).use(RadioGroup).use(Radio).use(Step).use(Steps).use(Search).use(Uploader).use(Tab).use(Tabs).use(Divider).use(Tabbar).use(TabbarItem).use(NavBar);

Vue.use(VueAxios, axios);

// Vue.use(wx);

// 接口请求地址
axios.defaults.baseURL = globalVariable.baseUrl;
// 设置跨域请求
axios.defaults.crossDomain = true;
// 允许携带cookie信息
axios.defaults.withCredentials = true;
// 设置请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

Vue.config.productionTip = false

// 引入loding
Vue.prototype.bus = new Vue;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  // wx,
  components: { App },
  template: '<App/>'
})

// 解决双击菜单是控制台弹出报错信息的问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/main.js